import style from './LoadingSpinner.module.css'

const LoadingSpinner = ({ children, ...props }) => (
  <div className={style.loader} {...props} />
)

export default LoadingSpinner
